/**
 * orga-app-api - kommunikation-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { MitteilungsVorlageDatenRequest } from '../model/mitteilungsVorlageDatenRequest';
// @ts-ignore
import { MitteilungsVorlageIdentifier } from '../model/mitteilungsVorlageIdentifier';
// @ts-ignore
import { MitteilungsVorlageRequest } from '../model/mitteilungsVorlageRequest';
// @ts-ignore
import { MitteilungsVorlageRolleMultiRequest } from '../model/mitteilungsVorlageRolleMultiRequest';
// @ts-ignore
import { MitteilungsVorlageTypMultiRequest } from '../model/mitteilungsVorlageTypMultiRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class MitteilungsVorlageCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostMitteilungsVorlageAktualisieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * MitteilungsVorlageNichtGefunden: (MitteilungsVorlageNichtGefunden) * MitteilungsVorlageGeloescht: (MitteilungsVorlageGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/kom/command/mitteilungsvorlagen/v1/aktualisieren
     * @param mitteilungsVorlageDatenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postMitteilungsVorlageAktualisieren(mitteilungsVorlageDatenRequest: MitteilungsVorlageDatenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MitteilungsVorlageIdentifier>;
    public postMitteilungsVorlageAktualisieren(mitteilungsVorlageDatenRequest: MitteilungsVorlageDatenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageAktualisieren(mitteilungsVorlageDatenRequest: MitteilungsVorlageDatenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageAktualisieren(mitteilungsVorlageDatenRequest: MitteilungsVorlageDatenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mitteilungsVorlageDatenRequest === null || mitteilungsVorlageDatenRequest === undefined) {
            throw new Error('Required parameter mitteilungsVorlageDatenRequest was null or undefined when calling postMitteilungsVorlageAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/kom/command/mitteilungsvorlagen/v1/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MitteilungsVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mitteilungsVorlageDatenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostMitteilungsVorlageAnlegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/kom/command/mitteilungsvorlagen/v1/anlegen
     * @param mitteilungsVorlageDatenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postMitteilungsVorlageAnlegen(mitteilungsVorlageDatenRequest: MitteilungsVorlageDatenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MitteilungsVorlageIdentifier>;
    public postMitteilungsVorlageAnlegen(mitteilungsVorlageDatenRequest: MitteilungsVorlageDatenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageAnlegen(mitteilungsVorlageDatenRequest: MitteilungsVorlageDatenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageAnlegen(mitteilungsVorlageDatenRequest: MitteilungsVorlageDatenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mitteilungsVorlageDatenRequest === null || mitteilungsVorlageDatenRequest === undefined) {
            throw new Error('Required parameter mitteilungsVorlageDatenRequest was null or undefined when calling postMitteilungsVorlageAnlegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/kom/command/mitteilungsvorlagen/v1/anlegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MitteilungsVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mitteilungsVorlageDatenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostMitteilungsVorlageEmpfaengerRollenEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * MitteilungsVorlageNichtGefunden: (MitteilungsVorlageNichtGefunden) * MitteilungsVorlageGeloescht: (MitteilungsVorlageGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/kom/command/mitteilungsvorlagen/v1/rollen/empfaenger/entfernen
     * @param mitteilungsVorlageRolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postMitteilungsVorlageEmpfaengerRollenEntfernen(mitteilungsVorlageRolleMultiRequest: MitteilungsVorlageRolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MitteilungsVorlageIdentifier>;
    public postMitteilungsVorlageEmpfaengerRollenEntfernen(mitteilungsVorlageRolleMultiRequest: MitteilungsVorlageRolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageEmpfaengerRollenEntfernen(mitteilungsVorlageRolleMultiRequest: MitteilungsVorlageRolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageEmpfaengerRollenEntfernen(mitteilungsVorlageRolleMultiRequest: MitteilungsVorlageRolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mitteilungsVorlageRolleMultiRequest === null || mitteilungsVorlageRolleMultiRequest === undefined) {
            throw new Error('Required parameter mitteilungsVorlageRolleMultiRequest was null or undefined when calling postMitteilungsVorlageEmpfaengerRollenEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/kom/command/mitteilungsvorlagen/v1/rollen/empfaenger/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MitteilungsVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mitteilungsVorlageRolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostMitteilungsVorlageEmpfaengerRollenHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * MitteilungsVorlageNichtGefunden: (MitteilungsVorlageNichtGefunden) * MitteilungsVorlageGeloescht: (MitteilungsVorlageGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/kom/command/mitteilungsvorlagen/v1/rollen/empfaenger/hinzufuegen
     * @param mitteilungsVorlageRolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postMitteilungsVorlageEmpfaengerRollenHinzufuegen(mitteilungsVorlageRolleMultiRequest: MitteilungsVorlageRolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MitteilungsVorlageIdentifier>;
    public postMitteilungsVorlageEmpfaengerRollenHinzufuegen(mitteilungsVorlageRolleMultiRequest: MitteilungsVorlageRolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageEmpfaengerRollenHinzufuegen(mitteilungsVorlageRolleMultiRequest: MitteilungsVorlageRolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageEmpfaengerRollenHinzufuegen(mitteilungsVorlageRolleMultiRequest: MitteilungsVorlageRolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mitteilungsVorlageRolleMultiRequest === null || mitteilungsVorlageRolleMultiRequest === undefined) {
            throw new Error('Required parameter mitteilungsVorlageRolleMultiRequest was null or undefined when calling postMitteilungsVorlageEmpfaengerRollenHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/kom/command/mitteilungsvorlagen/v1/rollen/empfaenger/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MitteilungsVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mitteilungsVorlageRolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostMitteilungsVorlageEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * MitteilungsVorlageNichtGefunden: (MitteilungsVorlageNichtGefunden) * MitteilungsVorlageGeloescht: (MitteilungsVorlageGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/kom/command/mitteilungsvorlagen/v1/entfernen
     * @param mitteilungsVorlageRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postMitteilungsVorlageEntfernen(mitteilungsVorlageRequest: MitteilungsVorlageRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MitteilungsVorlageIdentifier>;
    public postMitteilungsVorlageEntfernen(mitteilungsVorlageRequest: MitteilungsVorlageRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageEntfernen(mitteilungsVorlageRequest: MitteilungsVorlageRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageEntfernen(mitteilungsVorlageRequest: MitteilungsVorlageRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mitteilungsVorlageRequest === null || mitteilungsVorlageRequest === undefined) {
            throw new Error('Required parameter mitteilungsVorlageRequest was null or undefined when calling postMitteilungsVorlageEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/kom/command/mitteilungsvorlagen/v1/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MitteilungsVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mitteilungsVorlageRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostMitteilungsVorlageKopieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * MitteilungsVorlageNichtGefunden: (MitteilungsVorlageNichtGefunden) * MitteilungsVorlageGeloescht: (MitteilungsVorlageGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) * MitteilungsVorlageQuelleNichtBefuellt: (MitteilungsVorlageQuelleNichtBefuellt) 
     * @endpoint post /api/kom/command/mitteilungsvorlagen/v1/kopieren
     * @param mitteilungsVorlageRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postMitteilungsVorlageKopieren(mitteilungsVorlageRequest: MitteilungsVorlageRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MitteilungsVorlageIdentifier>;
    public postMitteilungsVorlageKopieren(mitteilungsVorlageRequest: MitteilungsVorlageRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageKopieren(mitteilungsVorlageRequest: MitteilungsVorlageRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageKopieren(mitteilungsVorlageRequest: MitteilungsVorlageRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mitteilungsVorlageRequest === null || mitteilungsVorlageRequest === undefined) {
            throw new Error('Required parameter mitteilungsVorlageRequest was null or undefined when calling postMitteilungsVorlageKopieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/kom/command/mitteilungsvorlagen/v1/kopieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MitteilungsVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mitteilungsVorlageRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostMitteilungsVorlageVeranstaltungsTypenEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * MitteilungsVorlageNichtGefunden: (MitteilungsVorlageNichtGefunden) * MitteilungsVorlageGeloescht: (MitteilungsVorlageGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/kom/command/mitteilungsvorlagen/v1/veranstaltungstypen/entfernen
     * @param mitteilungsVorlageTypMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postMitteilungsVorlageVeranstaltungsTypenEntfernen(mitteilungsVorlageTypMultiRequest: MitteilungsVorlageTypMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MitteilungsVorlageIdentifier>;
    public postMitteilungsVorlageVeranstaltungsTypenEntfernen(mitteilungsVorlageTypMultiRequest: MitteilungsVorlageTypMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageVeranstaltungsTypenEntfernen(mitteilungsVorlageTypMultiRequest: MitteilungsVorlageTypMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageVeranstaltungsTypenEntfernen(mitteilungsVorlageTypMultiRequest: MitteilungsVorlageTypMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mitteilungsVorlageTypMultiRequest === null || mitteilungsVorlageTypMultiRequest === undefined) {
            throw new Error('Required parameter mitteilungsVorlageTypMultiRequest was null or undefined when calling postMitteilungsVorlageVeranstaltungsTypenEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/kom/command/mitteilungsvorlagen/v1/veranstaltungstypen/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MitteilungsVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mitteilungsVorlageTypMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostMitteilungsVorlageVeranstaltungsTypenHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * MitteilungsVorlageNichtGefunden: (MitteilungsVorlageNichtGefunden) * MitteilungsVorlageGeloescht: (MitteilungsVorlageGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/kom/command/mitteilungsvorlagen/v1/veranstaltungstypen/hinzufuegen
     * @param mitteilungsVorlageTypMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postMitteilungsVorlageVeranstaltungsTypenHinzufuegen(mitteilungsVorlageTypMultiRequest: MitteilungsVorlageTypMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MitteilungsVorlageIdentifier>;
    public postMitteilungsVorlageVeranstaltungsTypenHinzufuegen(mitteilungsVorlageTypMultiRequest: MitteilungsVorlageTypMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageVeranstaltungsTypenHinzufuegen(mitteilungsVorlageTypMultiRequest: MitteilungsVorlageTypMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MitteilungsVorlageIdentifier>>;
    public postMitteilungsVorlageVeranstaltungsTypenHinzufuegen(mitteilungsVorlageTypMultiRequest: MitteilungsVorlageTypMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mitteilungsVorlageTypMultiRequest === null || mitteilungsVorlageTypMultiRequest === undefined) {
            throw new Error('Required parameter mitteilungsVorlageTypMultiRequest was null or undefined when calling postMitteilungsVorlageVeranstaltungsTypenHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/kom/command/mitteilungsvorlagen/v1/veranstaltungstypen/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MitteilungsVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mitteilungsVorlageTypMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
